import { Button, Typography } from 'antd';
import type { CardProps as AntdCardProps } from 'antd';
import { useNavigate } from 'react-router';
import tw from 'twin.macro';

import { PATH } from '@/Route';
import Card from '@/components/Card';
import { useProduct } from '@/hooks/queries/partner';
import useBelowWidth from '@/hooks/useBelowWidth';

import PriceItem from './PriceItem';

interface ProductItemProps extends AntdCardProps {
  productId: number;
  url: string;
  name: string;
  summary: string;
  price: number;
  discountPrice: number;
  useApplyButton?: boolean;
}
export const ProductItemBox = ({
  productId,
  title,
  url,
  name,
  summary,
  price,
  discountPrice,
  useApplyButton,
  ...rest
}: ProductItemProps) => {
  const navigate = useNavigate();
  const max768 = useBelowWidth(768);

  const { data } = useProduct({ id: Number(productId) });

  return (
    <Card
      title={title}
      styles={{
        body: {
          width: '100%',
          display: 'flex',
          flexDirection: max768 ? 'column' : 'row',
        },
      }}
      {...rest}
    >
      <img
        alt={`${name} 이미지`}
        src={url}
        onDragStart={(e) => e.preventDefault()}
        css={[
          tw`max-w-full max-h-[120px] aspect-[3/2] mr-[24px] mb-0 object-cover`,
          useApplyButton && tw`max-h-[180px]`,
          tw`x768:(mb-[24px] mr-0)`,
        ]}
      />
      <dl css={tw`flex flex-col self-stretch justify-between`}>
        <dt css={tw`flex flex-col items-start`}>
          <Typography.Text css={tw`font-semibold leading-[24px] text-[16px]`}>
            {name}
          </Typography.Text>
          <Typography.Text css={tw`mt-[8px] leading-[22px] text-[14px]`}>
            {summary}
          </Typography.Text>
        </dt>
        <dd css={tw`flex flex-col items-start gap-[20px]`}>
          <PriceItem price={price} discountPrice={discountPrice} />

          {useApplyButton && (
            <Button
              type="primary"
              onClick={() => {
                if (data) {
                  navigate(PATH.MARKETING_PRODUCT.ORDER, {
                    state: {
                      ...data,
                    },
                  });
                }
              }}
            >
              신청하기
            </Button>
          )}
        </dd>
      </dl>
    </Card>
  );
};
